import React from "react";
import { Box, Button, Card, CardContent, Grid } from "@material-ui/core";
import { Settings as SettingsIcon, Help as HelpIcon } from "@material-ui/icons";
import { Link } from "../util/router"; // Assuming Link is correctly imported/used
import useDashboardSectionStyles from "./useDashboardSectionStyles"; // Reuse styles if applicable
import AboutSection from "./AboutSection";
import { useAuth } from "../util/auth"; // Needed for AboutSection

function QuickLinksFooter() {
  const classes = useDashboardSectionStyles(); // Or create specific styles
  const auth = useAuth(); // Get auth info for AboutSection

  return (
    <Box mt={3} display="flex" justifyContent="center">
      <Card className={classes.footerCard} elevation={1}>
        <CardContent>
          <Grid container spacing={2} justifyContent="center">
            <Grid item>
              <Button
                variant="outlined"
                size="small"
                className={classes.quickLinkButton}
                startIcon={<SettingsIcon />}
                component={Link}
                to="/settings/general"
              >
                Settings
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                size="small"
                className={classes.quickLinkButton}
                startIcon={<HelpIcon />}
                component={Link}
                to="/faq"
              >
                Help
              </Button>
            </Grid>
          </Grid>
          <Box mt={2}>
            {/* Pass auth object to AboutSection if it needs it */}
            <AboutSection auth={auth} />
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}

export default QuickLinksFooter;
